import React, { FC, ReactNode } from "react";

import { IconButton } from "../../../../buttons/icon-button";
import { IconName } from "../../../../icon";

export interface PersonalAreaCardProps {
  title: ReactNode;
  icon: IconName;
  body?: ReactNode;
  cta?: ReactNode;
}

export const PersonalAreaCard: FC<PersonalAreaCardProps> = ({ icon, title, body, cta }) => {
  return (
    <div className="flex flex-col gap-4 items-center p-8 rounded-4xl bg-neutral-light">
      <IconButton size="extralarge" icon={icon} variant="light" className="text-primary" />
      {title && <h3 className="text-3xl text-primary">{title}</h3>}
      <p className="text-center">{body}</p>
      {cta}
    </div>
  );
};
